import React from "react";
import { Redirect,} from 'react-router-dom';

import { useHistory } from 'react-router-dom';
// react plugin for creating charts
//import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
//import Icon from "@material-ui/core/Icon";
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { fa-temperature-high } from '@fortawesome/free-solid-svg-icons'


// @material-ui/icons
//import Store from "@material-ui/icons/Store";
// import Warning from "@material-ui/icons/Warning";
//import DateRange from "@material-ui/icons/DateRange";
//import LocalOffer from "@material-ui/icons/LocalOffer";
//import Update from "@material-ui/icons/Update";
//import ArrowUpward from "@material-ui/icons/ArrowUpward";
//import AccessTime from "@material-ui/icons/AccessTime";
//import Accessibility from "@material-ui/icons/Accessibility";
//import BugReport from "@material-ui/icons/BugReport";
//import Code from "@material-ui/icons/Code";
//import Cloud from "@material-ui/icons/Cloud";
import ThermostatIcon from '@mui/icons-material/Thermostat';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import BoltIcon from '@mui/icons-material/Bolt';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'


// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
//import Table from "components/Table/Table.js";
//import Tasks from "components/Tasks/Tasks.js";
//import CustomTabs from "components/CustomTabs/CustomTabs.js";
//import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import WeatherMain from "components/WeatherMain/WeatherMain";
import Forecast from "components/Weather/Forecast";

//import { bugs, website, server } from "variables/general.js";

/* import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart,
} from "variables/charts.js"; */

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
//import CustomAreaChart from "components/CustomAreaChart/CustomAreaChart";
import CustomAreaChartSmall from "components/CustomAreaChartSmall/CustomAreaChartSmall";
//import CustomLineChart from "components/CustomLineChart/CustomLineChart";
import CustomLineChartNPKSmall from "components/CustomLineChart/CustomLineChartNPKSmall";
//import MapSensorList from "components/MapSensorList/MapSensorList";
import MapPlantacion from "components/MapPlantacion/MapPlantacion";

import { useSelector, useDispatch } from 'react-redux';

//import { fetchDashboarData } from '../../store/data-actions'

import { useState, useEffect} from "react";
import { fetchConToken } from "helpers/fetch";
import { startLogout } from '../../store/auth-actions'


import Swal from 'sweetalert2';
import DataTablePlantaciones from "components/DataTablePlantaciones/DataTablePlantaciones";
import SensorsTable from 'components/SensorsTable/SensorsTable'
import { getSensors, getSensorsStr } from "helpers/sensors";


const useStyles = makeStyles(styles);


/* const location = {
  address: '1600 Amphitheatre Parkway, Mountain View, california.',
  lat: 37.42216,
  lng: -122.08427,
} */


const translations = {
  en: {
    lPlantaciones: "Crops",
    lClima: "Weather",
    lPronos: "Weather Forecast",
    lSoilTemp: "Soil Temperature",
    lSoilMoist: "Soil Moisture",
    lSoilPH: "Soil PH",
    lEc: "Electrical Conductivity (EC)",
    lNPK: "Nitrogen, Phosphorus, Potasium mg/kg",
    lBattery: "Battery Charge",
    lError: "Error Loading dashboard",
    lAuth: "Unauthorized or Expired session",
  },
  es: {
    lPlantaciones: "Plantaciones",
    lClima: "Clima",
    lPronos: "Pronóstico del Clima",
    lSoilTemp: "Temperatura del Suelo",
    lSoilMoist: "Humedad del Suelo",
    lSoilPH: "PH del Suelo",
    lEc: "Conductividad Eléctrica (EC)",
    lNPK: "Nitrógeno, Fósforo, Potasio mg/kg",
    lBattery: "Carga de Batería",
    lError: "Error al cargar Tablero",
    lAuth: "Sin Autorización o Sesión Expirada",
  }
};



export default function Dashboard() {
  
  const {language} = useSelector( state => state.data); 
  const t = translations[language];

  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const {  checking, isLoggedin } = useSelector( state => state.auth);  //index para seleccion de plantaciones
  const { plantaciones, allPlantaciones, indexPlantacion,} = useSelector( state => state.data);

  //let [sensorsStrProps, setSensorsStrProps] = useState("");
  

  //let sensors = ["65d993f557cacc29"]; //moved to MapSensor List
  let sensors = getSensors(plantaciones, allPlantaciones, indexPlantacion);
  let sensorList = getSensorsStr(sensors);
   

 console.log("sensorList Dashboard:", sensorList);
  //const { start, query, sensors, fillcolor, strokecolor } = props;

  let [voltage_average, setVoltageAverage] = useState("");
  let [ec_average, setEcAverage] = useState("");
  let [ph_average, setPhAverage] = useState("");
  let [N_average, setNAverage] = useState("");
  let [P_average, setPAverage] = useState("");
  let [K_average, setKAverage] = useState("");
  let [soil_temp_average, setSoilTempAverage] = useState("");
  let [soil_moist_average, setSoilMoistAverage] = useState("");
  //let [data2, setData2] = useState([]);

  let [redirect, setRedirect] = useState(false);

  useEffect(() => {
      let mounted = true;
      console.log("Mounted Dashboard:");
      //dispatch(fetchDashboarData());
        
      //query all averages for each card near real-time measure
      const query = "all_average";
      const start = "-12h";
      
      // setSensorsStrProps(sensorStr);

      const fetchData = async () => {
        try {
          const resp = await fetchConToken( `data?start=`+start+`&query=`+query+ `&sensors=`+sensorList )
          const body = await resp.json();
          
          //console.log("dataAverage:" + body);
          //console.log(JSON.stringify(body) );
          
          if( body.ok ) {
              if(mounted) {
                //setAverages(body.data)
                
                let int_averages = body.data.map((entry)=>{
                  console.log("Measurement in item averages:",entry.measurement);
                  switch ( entry.measurement ) {
                    case "device_frmpayload_data_voltage":
                      return {measure: "voltage", value: entry.value }
                    case "device_frmpayload_data_ph":
                      return {measure: "ph", value: entry.value }
                    case "device_frmpayload_data_ec":
                      return {measure: "ec", value: entry.value }
                    case "device_frmpayload_data_N":
                      return {measure: "n", value: entry.value }
                    case "device_frmpayload_data_P":
                      return {measure: "p", value: entry.value }
                    case "device_frmpayload_data_K":
                      return {measure: "k", value: entry.value }
                    case "device_frmpayload_data_soil_temp":
                      return {measure: "soil_temp", value: entry.value }
                    case "device_frmpayload_data_soil_moist":
                      return {measure: "soil_moist", value: entry.value }
                    default:
                      return {measure: "voltage", value: entry.value }
                  }
                  
                  
                }) 
                //setAverages(int_averages);
                console.log("found volt:"+int_averages.find(item => item.measure === "voltage"));
                //console.log("found ec:"+int_averages.find(item => item.measure === "ec"));
                //console.log("found altitude:"+int_averages.find(item => item.measure === "altitude"));
                

                let voltageAverage = "No data";
                (int_averages.find(item => item.measure === "voltage")) && (voltageAverage = ''+(int_averages.find(item => item.measure === "voltage").value).toFixed(1));
                setVoltageAverage(voltageAverage);

                let ecAverage = "No data";
                (int_averages.find(item => item.measure === "ec")) && (ecAverage = ''+(int_averages.find(item => item.measure === "ec").value).toFixed(0));
                setEcAverage(ecAverage);

                let phAverage = "No data";
                (int_averages.find(item => item.measure === "ph")) && ( phAverage = ''+(int_averages.find(item => item.measure === "ph").value/100).toFixed(1));
                setPhAverage(phAverage);

                let NAverage = "No data";
                (int_averages.find(item => item.measure === "n")) && ( NAverage = ''+(int_averages.find(item => item.measure === "n").value).toFixed(1));
                setNAverage(NAverage);

                let PAverage = "No data";
                (int_averages.find(item => item.measure === "p")) && ( PAverage = ''+(int_averages.find(item => item.measure === "p").value).toFixed(1));
                setPAverage(PAverage);

                let KAverage = "No data";
                (int_averages.find(item => item.measure === "k")) && ( KAverage = ''+(int_averages.find(item => item.measure === "k").value).toFixed(1));
                setKAverage(KAverage);

                let SoilTempAverage = "No data";
                (int_averages.find(item => item.measure === "soil_temp")) && ( SoilTempAverage = ''+(int_averages.find(item => item.measure === "soil_temp").value).toFixed(1));
                setSoilTempAverage(SoilTempAverage);
                
                let SoilMoistAverage = "No data";
                (int_averages.find(item => item.measure === "soil_moist")) && ( SoilMoistAverage = ''+(int_averages.find(item => item.measure === "soil_moist").value).toFixed(1));
                setSoilMoistAverage(SoilMoistAverage);
              

                //console.log(''+(averages.find(item => item.measure === "voltage").value).toFixed(2));
                //setData2(modifiedDate);

              }
          }else{
           /*  if (body.expired){
              Swal.fire('Autenticacion', "No Autorizado o Sesión expirada", 'error');
            } */
            throw new Error(t.lError);
             
            
          }
        } catch (error) {
          console.log(error);
           Swal.fire('Error code:0xD006', t.lAuth, 'error');
           dispatch( startLogout());
           history.replace('/login');
           
              
        }
      }
      
        
       
        
        fetchData();
        
        return () => mounted = false;
  }, [indexPlantacion, allPlantaciones])

  /////

  if ( checking ) {
     
    return (
        <div style={{padding: '10px', width: '80px', height: '80px'}}>
            <LoadingSpinner />
        </div>
        );
  }

 
  return (
    
   

  <div>
     {(isLoggedin) && (


     

        <GridContainer>
            <GridItem xs={12} sm={12} md={6} lg={4}>
              <Card >
                <CardHeader color="green">
                  <h4 className={classes.cardTitleWhite}>{t.lPlantaciones}</h4>
                </CardHeader>
                
                <CardBody>
                  {/* <div style={{ display: 'flex', flexDirection: 'row', padding: '10px', flexWrap: 'wrap' }}> */}
                      <div style={{display: 'flex', flexDirection: 'column', padding: '10px', width: '100%', height: '100%', }}>
                          <div>
                            <DataTablePlantaciones />
                          </div>
                          <div className={classes.map} style={{ width: '100%', height: '300px', padding: '10px'}}> 
                            <MapPlantacion   />
                          </div> 
                          <div>
                            <SensorsTable start="-1h" sensors={sensors}/>
                          </div>
                      </div>
                      
                        
                  {/* </div> */}
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={12} md={6} lg={8}>     
                <GridContainer >
                    
                      <GridItem xs={12} sm={12} md={12} lg={6}>
                        <Card >
                          <CardHeader color="green">
                            <h4 className={classes.cardTitleWhite}>{t.lClima}</h4>
                          </CardHeader>
                          {/* <CardHeader color="gray">
                            <h4 className={classes.cardTitleWhite}>Clima Actual</h4>
                          </CardHeader>  */}
                          <CardBody >
                            <WeatherMain />
                          </CardBody>
                          {/* <CardFooter chart>
                            <div className={classes.stats}>
                            <AccessTime /> OpenWeather API
                            </div>
                          </CardFooter> */}
                        </Card>
                      </GridItem>
                      
                      <GridItem xs={12} sm={12} md={12} lg={6}>
                        <Card  >
                          <CardHeader color="green">
                            <h4 className={classes.cardTitleWhite}>{t.lPronos}</h4>
                          </CardHeader>
                          
                          <CardBody>
                            <Forecast  />
                          </CardBody>
                          {/* <CardFooter chart>
                            <div className={classes.stats}>
                            <AccessTime /> OpenWeather API
                            </div>
                          </CardFooter> */}
                        </Card>
                      </GridItem>

                </GridContainer>
                <GridContainer >
                      <GridItem xs={12} sm={12} md={6} lg={4}>
                        <Card >
                          <CardHeader color="warning" stats icon>
                            <CardIcon color="warning">
                              <ThermostatIcon />
                              {/* <Icon>content_copy</Icon> */}
                              {/* <Icon baseClassName="fas" className="fa-solid fa-temperature-high" /> */}
                              {/* <FontAwesomeIcon icon="fa-solid fa-temperature-high" /> */}

                            </CardIcon>
                            <p className={classes.cardCategory}>{t.lSoilTemp}</p>
                            <h2 className={classes.cardTitle} style={{fontSize: '30px'}}>
                            {soil_temp_average} <small>°C</small>
                            </h2>
                          </CardHeader>
                          <CardFooter chart style={{flexDirection:'column', padding:'5px', marginLeft:'1px', height:'100px'}}>
                              <CustomAreaChartSmall start="-12h" query="mean_soil_temp" sensors={sensorList} strokecolor='#DD7B13' fillcolor='#FE952D' units='°C' factor={1} />

                            {/*  <div className={classes.stats}>
                                <Danger>
                                  <Warning />
                                </Danger>
                                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                                  Get more space
                                </a>
                              </div> */}

                            
                            
                            
                          </CardFooter>
                        </Card>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6} lg={4}>
                        <Card>
                          <CardHeader color="success" stats icon>
                            <CardIcon color="success">
                            
                              <LocalDrinkIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>{t.lSoilMoist}</p>
                            <h2 className={classes.cardTitle} style={{fontSize: '30px'}}>
                              {soil_moist_average} <small>%</small>
                            </h2>
                          </CardHeader>
                          <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                            <CustomAreaChartSmall start="-12h" query="mean_soil_moist" sensors={sensorList} strokecolor='#29B24F' fillcolor='#2FD15C' units='%' factor={1} />
                          {/*  <div className={classes.stats}>
                              <DateRange />
                              Last 24 Hours
                            </div> */}
                          </CardFooter>
                        </Card>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6} lg={4}>
                        <Card>
                          <CardHeader color="danger" stats icon>
                            <CardIcon color="danger">
                              <AutoGraphIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>{t.lSoilPH}</p>
                            <h2 className={classes.cardTitle} style={{fontSize: '30px'}}>
                              {ph_average} <small>pH</small>
                            </h2>
                          </CardHeader>
                          <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                            <CustomAreaChartSmall start="-12h" query="mean_ph" sensors={sensorList} strokecolor='#AF1F1F' fillcolor='#E02D2D' units='pH' factor={1} />
                            
                            {/* <div className={classes.stats}>
                              <LocalOffer />
                              Tracked from Github
                            </div> */}
                          </CardFooter>
                        </Card>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6} lg={4}>
                        <Card>
                          <CardHeader color="info" stats icon>
                            <CardIcon color="info">
                              <BoltIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>{t.lEc}</p>
                            <h2 className={classes.cardTitle} style={{fontSize: '30px'}}>
                              {ec_average} <small>mS/m</small>
                            </h2>
                          </CardHeader>
                          <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                            <CustomAreaChartSmall start="-12h" query="mean_ec" sensors={sensorList} strokecolor='#1A759F' fillcolor='#2C95C5' units='mS/m' factor={1} />
                              {/* <div className={classes.stats}>
                              <Update />
                              Just Updated
                            </div> */}
                          </CardFooter>
                        </Card>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6} lg={4}>
                      <Card chart>
                        
                          <CardHeader color="primary" stats icon>
                          <CardIcon color="info">
                          <h2 className={classes.cardTitle} style={{fontSize: '20px', fontWeight: '600', color: 'white'}}> NPK </h2>
                          </CardIcon>
                            {/* <p className={classes.cardCategory}>NPK</p>
                            <p></p> */}
                            <p className={classes.cardCategory}>{t.lNPK}</p>

                            
                            <h4 style={{display: "inline", color: "#8884d8", fontSize: '18px', fontWeight:'bold'}}> 
                              N: &nbsp;
                            </h4>
                            <h4 style={{display: "inline", color: "#8884d8", fontSize: '15px', fontWeight:'bold'}}> 
                              {N_average},  &nbsp;
                            </h4>

                            <h4 style={{display: "inline", color: "#82ca9d", fontSize: '18px', fontWeight:'bold'}}> 
                              P: &nbsp;
                            </h4>
                            <h4 style={{display: "inline", color: "#82ca9d", fontSize: '15px', fontWeight:'bold'}}> 
                              {P_average}, &nbsp; 
                            </h4>

                            <h4 style={{display: "inline", color: "#85cafd", fontSize: '18px', fontWeight:'bold'}}> 
                              K:&nbsp;
                            </h4>
                            <h4 style={{display: "inline", color: "#85cafd", fontSize: '15px', fontWeight:'bold'}}> 
                              {K_average} &nbsp; 
                            </h4>

                            
                          </CardHeader>

                          <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'120px'}}>
                            <CustomLineChartNPKSmall start="-12h" query="npk_over_time" sensors={sensorList} />
                            
                            {/*  <div className={classes.stats}>
                              <Update />
                              Just Updated
                            </div> */}
                          </CardFooter>


                      </Card>
                      
                      

                      </GridItem>
                  

                      <GridItem xs={12} sm={12} md={6} lg={4}>
                        <Card>
                          <CardHeader color="info" stats icon>
                            <CardIcon color="info">
                              <BoltIcon />
                            </CardIcon>
                            <p className={classes.cardCategory}>{t.lBattery}</p>
                            <h2 className={classes.cardTitle} style={{fontSize: '30px'}}>
                            {voltage_average} <small>V.</small>
                            </h2>
                          </CardHeader>
                          <CardFooter chart style={{flexDirection:'column', padding:'2px', marginLeft:'1px', height:'100px'}}>
                            <CustomAreaChartSmall start="-12h" query="mean_voltage" sensors={sensorList} strokecolor='#1A759F' fillcolor='#2C95C5' units='V' factor={1} />
                              {/* <div className={classes.stats}>
                              <Update />
                              Just Updated
                            </div> */}
                          </CardFooter>
                        </Card>
                      </GridItem>

                </GridContainer>
            </GridItem>

          </GridContainer>


    )}


    </div>
  );
}
